module.exports = __webpack_public_path__ + "static/media/DISPATCH_LOAD.33d01911.svg";